
import CropMixin from '../../../../mixins/cropper'
import { childValidator } from '../../../../fc/advancedOptionHelper'
import TextField from './Text'
import SelectField from './Select'
import TimePickerField from './TimePicker'
import CheckboxField from './Checkbox'
import SliderField from './Slider'
import RadioField from './Radio'
import CustomDimensionField from './CustomDimension'
import RadioButtonsField from './RadioButtons'
import ColorPickerField from './Color'
import CropToggleField from './CropToggle'
import FileInputField from './FileInput'
import { secondsToHHMMSS } from '~/fc/dateFormatter'

export default {
  name: 'FieldChild',
  components: {
    'field-parent': () => import('./FieldParent.vue'),
    CheckboxField,
    TimePickerField,
    SelectField,
    SliderField,
    TextField,
    RadioField,
    CustomDimensionField,
    ColorPickerField,
    RadioButtonsField,
    CropToggleField,
    FileInputField
  },
  mixins: [CropMixin],
  props: ['field', 'uid', 'slug'],
  computed: {
    selection () {
      return this.$store.state.advancedSetting.userData.allSelection &&
              this.$store.state.advancedSetting.userData.allSelection[this.uid]
        ? this.$store.state.advancedSetting.userData.allSelection[this.uid]
        : {}
    },
    childrens () {
      return childValidator(this.field, this.selection)
    },
    isCropPosition() {
      return ['crop-position-x', 'crop-position-y', 'crop_ratio_x', 'crop_ratio_y'].includes(this.field.name) && this.field.name && this.field.id
    }
  },
  mounted() {
    if(this.isCropPosition) {
      this.$store.commit('advancedSetting/setCropSettingsIds', this.field)
    }
  },
  methods: {
    applySelection (value) {
      if (this.isCropPosition) return
      if (this.$store.state.info.customVariables && this.$store.state.info.customVariables.enableCropper) {
        this.applyCropSelection(value)
      } else {
        this.$store.commit('advancedSetting/setSelection', { uid: this.uid, slug: this.slug, key: this.field.id, value, fromUpdate: true })
      }
    },
    applyCropSelection (value) {
      this.commitCropChanges({ uid: this.uid, field: this.field, value })
    },
    onButtonClick (data) {
      this.$store.commit('advancedSetting/setSelection', {
        uid: 'root',
        key: data,
        value: secondsToHHMMSS(Math.floor(window.player.currentTime()))
      })
    }
  }
}
